module.exports = __webpack_public_path__ + "img/darkcity.91c5abf3.svg";